import React, { useLayoutEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { StyledFarePrice } from './LowestFareFinder.styles';

const FarePrice = ({ fare, currency, cheapest, intl }) => {
  const ref = useRef(null);

  useLayoutEffect(() => {
    const badge = ref.current;
    const day = badge.parentElement;
    const fit = () => {
      badge.style.fontSize = '';
      const fontSize = parseFloat(window.getComputedStyle(badge).fontSize);
      const dayStyle = window.getComputedStyle(day);
      const available = day.clientWidth - parseFloat(dayStyle.paddingLeft) - parseFloat(dayStyle.paddingRight);
      const width = badge.scrollWidth;
      // Leave room for the badge's horizontal padding when fitting the text.
      if (available > 4 && width > available) {
        badge.style.fontSize = `${(fontSize * (available - 4)) / (width - 4)}px`;
      }
    };

    fit();

    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(fit) : null;
    observer?.observe(day);
    window.addEventListener('resize', fit);
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', fit);
    };
  }, [fare?.price, currency, intl.locale]);

  return (
    <StyledFarePrice
      ref={ref}
      className={cheapest ? 'cheapest' : ''}
      style={{ color: cheapest ? '#28623b' : '#222', backgroundColor: cheapest ? '#e6f1e9' : 'transparent' }}
    >
      {fare ? <FormattedCurrency currency={currency} amount={fare.price} hideEmptyDecimals /> : '–'}
    </StyledFarePrice>
  );
};

FarePrice.propTypes = {
  fare: PropTypes.shape({ price: PropTypes.number }),
  currency: PropTypes.string.isRequired,
  cheapest: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired
};

export default injectIntl(FarePrice);
